'use strict';

var React = require('react');

function _interopNamespace(e) {
	if (e && e.__esModule) return e;
	var n = Object.create(null);
	if (e) {
		Object.keys(e).forEach(function (k) {
			if (k !== 'default') {
				var d = Object.getOwnPropertyDescriptor(e, k);
				Object.defineProperty(n, k, d.get ? d : {
					enumerable: true,
					get: function () { return e[k]; }
				});
			}
		});
	}
	n["default"] = e;
	return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SvgHamburgerMenu = props => /*#__PURE__*/React__namespace.createElement("svg", _extends({
  overflow: "visible",
  preserveAspectRatio: "none",
  viewBox: "0 0 20 20",
  height: 24,
  width: 24
}, props), _g || (_g = /*#__PURE__*/React__namespace.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React__namespace.createElement("rect", {
  x: 1,
  y: 2,
  width: 18,
  height: 3,
  rx: 1
}), /*#__PURE__*/React__namespace.createElement("rect", {
  x: 1,
  y: 8,
  width: 18,
  height: 3,
  rx: 1
}), /*#__PURE__*/React__namespace.createElement("rect", {
  x: 1,
  y: 14,
  width: 18,
  height: 3,
  rx: 1
}))));

exports["default"] = SvgHamburgerMenu;
